<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
            <label for="">{{ $t('common_words.farm') }}: </label>
            <br />
            <el-select
              id="farm_advanced"
              collapse-tags
              clearable
              filterable
              style="width: 100%"
              class="select-primary mb-3 required-farm_advanced shadow-sm"
              v-model="avancedReportForm.farm_id"
              :placeholder="`${$t('common_words.select2')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in farms"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
            <label for="">{{ $t('common_words.filter') }}: </label>
            <br />
            <el-select
              @change="getDiseasesOrPests()"
              clearable
              filterable
              style="width: 100%"
              class="select-primary custom-width-select mb-3 shadow-sm required-option"
              :placeholder="`${$t('common_words.select2')}...`"
              v-model="optionSel"
            >
              <el-option
                class="select-primary"
                v-for="item in getTypeReport"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
            <label for="">{{ $t('diseases.disease') }}: </label>
            <br />
            <el-select
              id="disease_advanced"
              collapse-tags
              clearable
              filterable
              style="width: 100%"
              class="select-primary mb-3 shadow-sm required-disease_advanced"
              v-model="avancedReportForm.diseases_ids"
              :placeholder="`${$t('common_words.select2')}...`"
            >
              <el-option
                class="select-primary"
                v-for="item in diseasesOrPests"
                :key="item.id + item.name"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-2 col-xl-2">
            <label>{{ $t('common_words.analyze_by') }} </label>
            <br />
            <el-select
              @change="changeByInterval"
              filterable
              @clear="avancedReportForm.bySel = null"
              clearable
              class="select-primary custom-width-select required-year shadow-sm"
              size="large"
              v-model="avancedReportForm.bySel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="option in Object.values(optionsInterval)"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.value"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-12 col-sm-8 col-md-6 col-lg-4 col-xl-3"
            v-if="
              avancedReportForm.bySel != 'week' &&
              avancedReportForm.bySel != 'year'
            "
          >
            <label>{{ $t('common_words.calendar') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              v-model="rangeDate"
              class="shadow-sm required-year"
              v-bind:type="typedatepicket"
              :picker-options="pickerOptions"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
              :start-placeholder="$t('common_words.initial_date')"
              :end-placeholder="$t('common_words.final_date')"
            >
            </el-date-picker>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-right: 0; padding-top: 29px"
            v-if="
              avancedReportForm.bySel == 'week' ||
              avancedReportForm.bySel == 'year'
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-year shadow-sm"
              size="large"
              v-model="avancedReportForm.year_sel_init"
            >
              <el-option
                v-for="(option, index) in years"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-top: 29px"
            v-if="
              avancedReportForm.bySel == 'week' &&
              avancedReportForm.year_sel_init
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-week shadow-sm"
              size="large"
              v-model="avancedReportForm.week_sel_init"
            >
              <el-option
                v-for="(week, index) in 53"
                class="select-primary"
                :value="week"
                :label="week"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-top: 29px"
            v-if="
              avancedReportForm.bySel == 'week' ||
              avancedReportForm.bySel == 'year'
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-year shadow-sm"
              size="large"
              v-model="avancedReportForm.year_sel_end"
            >
              <el-option
                v-for="(option, index) in years"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
            style="padding-top: 29px"
            v-if="
              avancedReportForm.bySel == 'week' &&
              avancedReportForm.year_sel_end
            "
          >
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-week shadow-sm"
              size="large"
              v-model="avancedReportForm.week_sel_end"
            >
              <el-option
                v-for="(week, index) in 53"
                class="select-primary"
                :value="week"
                :label="week"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-4 col-lg-1 col-xl-1">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="validate">
              {{ $t('common_words.filter') }}
            </l-button>
          </div>
        </div>
      </card>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        :title="$t('common_words.report_advanced')"
        v-if="avancedReport"
      >
        <div class="mt-4" v-if="isIndex()">
          <el-dialog
            :title="$t('common_words.samples_map')"
            class="map-height el-dialog-img-zoom"
            top="15px"
            width="80%"
            :visible.sync="modals.samplesMap"
            :close="handleCloseSamplesMap"
          >
            <div ref="multipleMap" class="map"></div>
            <div id="toolbarDiv" class="esri-component esri-widget">
              <button
                id="distance"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                style="margin-bottom: 10px"
                :title="$t('common_words.distance_measurement_tool')"
              ></button>
              <button
                id="area"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                style="margin-bottom: 10px"
                :title="$t('common_words.area_measurement_tool')"
              ></button>
              <button
                id="clear"
                class="action-button esri-widget--button esri-interactive esri-icon-trash"
                style="margin-bottom: 10px"
                :title="$t('common_words.clear_measurement')"
              ></button>
            </div>
          </el-dialog>

          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <img
              v-tooltip.top-center="$t('common_words.geo_location_map')"
              style="width: 30px; height: 30px"
              class="pointer"
              src="/static/img/iconos/map.svg"
              alt="Icono de Geolocalización"
              @click="handleViewAllSamplesMap"
            />
          </div>

          <br />

          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'date_save', order: 'descending' }"
              :data="queriedData"
              style="width: 100%; height: 100%"
              :border="true"
            >
              <!-- <el-table-column type="index" width="65"></el-table-column> -->
              <el-table-column
                prop="farm_name"
                :label="$t('common_words.farm')"
                :minWidth="150"
                :fixed="true"
              >
              </el-table-column>
              <el-table-column
                prop="lot_name"
                :label="$t('common_words.allotment')"
                :minWidth="150"
                :fixed="true"
              >
              </el-table-column>
              <el-table-column
                prop="disease_name"
                :label="$t('diseases.plague_or_disease')"
                :minWidth="170"
                :fixed="true"
              >
              </el-table-column>
              <el-table-column
                prop="tower"
                :label="$t('common_words.plant_code')"
                :minWidth="150"
              ></el-table-column>
              <el-table-column
                prop="date_save"
                :label="getLabelInterval"
                :minWidth="150"
              >
              </el-table-column>

              <el-table-column
                prop="disease_status"
                :label="$t('common_words.level_or_status')"
                minWidth="150"
              >
              </el-table-column>
              <el-table-column :label="$t('diseases.symptoms')" minWidth="150">
                <template slot-scope="scope">
                  <ul>
                    <li
                      v-for="(symptom, index) in scope.row.symptoms"
                      :key="index + row + 'symptom'"
                    >
                      {{ symptom.disease_symptom }}
                    </li>
                  </ul>
                </template>
              </el-table-column>

              <el-table-column
                :render-header="renderHeader"
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                align="center"
              >
              </el-table-column>

              <el-table-column
                prop="color"
                :label="$t('common_words.color')"
                v-if="false"
              >
              </el-table-column>

              <el-table-column
                prop="geometry_data"
                label="geometry"
                v-if="false"
              >
              </el-table-column>

              <el-table-column :label="$t('common_words.map')" min-width="150">
                <template slot-scope="props">
                  <img
                    v-tooltip.top-center="$t('common_words.perimeter_case')"
                    style="width: 30px; height: 30px"
                    class="pointer"
                    src="/static/img/iconos/map.svg"
                    alt="Icono de Geolocalización"
                    @click="handleViewSamplesMap(props.$index, props.row)"
                  />
                </template>
              </el-table-column>

              <el-table-column
                :label="$t('common_words.image')"
                min-width="150"
              >
                <template slot-scope="scope">
                  <el-image
                    v-if="scope.row.image"
                    :src="scope.row.image"
                    alt="Sin Imagen"
                    class="photo_capture"
                    @click="zoom(scope.row.image)"
                    :preview-src-list="srcList"
                  >
                    <div slot="error" class="image-slot"></div>
                  </el-image>
                  <span v-else></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
        <br />
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDF"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportExcel"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './advancedTable.js';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    LPagination,
  },

  computed: {
    optionsInterval() {
      return {
        0: { label: this.$i18n.t('common_words.day'), value: 'daterange' },
        1: { label: this.$i18n.t('common_words.week'), value: 'week' },
        2: { label: this.$i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: this.$i18n.t('common_words.year'), value: 'year' },
      };
    },
    getLabelInterval() {
      try {
        return Object.values(this.optionsInterval).find(
          (option) => option.value === this.avancedReportForm.bySel
        ).label;
      } catch (error) {
        return this.$i18n.t('common_words.interval');
      }
    },
    getTypeReport() {
      return [
        { id: 1, label: i18n.t('diseases.plague') },
        {
          id: 2,
          label: i18n.t('diseases.disease'),
        },
      ];
    },
  },

  data() {
    return {
      row: null,
      avancedReportForm: {
        bySel: 'week',
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        diseases_ids: null,
        farm_id: null,
      },
      typedatepicket: 'daterange',
      modals: {
        read: false,
        samplesMap: false,
      },
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      optionsStates: [],
      srcList: [],
      pagination: {},
      tableColumns: [],
      searchQuery: '',
      tableData: [],
      farms: [],
      years: [],
      optionSel: null,
      diseases: [],
      diseasesOrPests: [],
      avancedReport: false,
      map: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    MixinArcgisMap,
    mixinMasters,
    MixinExport,
    MixinMenu,
    MixinValidations,
  ],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll', 'forceRerender'],
  },

  methods: {
    renderHeader(h, { column }) {
      return h('div', [
        h('span', column.label.split('-')[0]),
        h('br'),
        h('span', column.label.split('-')[1]),
      ]);
    },

    zoom(url) {
      this.srcList = [];
      this.srcList.push(url);
    },

    changeByInterval() {
      this.avancedReport = false;
      this.typedatepicket = this.avancedReportForm.bySel;
    },

    getDiseasesOrPests() {
      let resp = [];
      this.avancedReportForm.diseases_ids = null;
      if (isset(this.optionSel)) {
        resp = this.diseases.filter(
          (disease) => disease.type_p_e === this.optionSel
        );
      }
      this.diseasesOrPests = resp;
    },

    validate() {
      this.tableData = [];
      this.avancedReport = false;
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.avancedReportForm.farm_id)) {
            return this.validationInputsRequired('farm_advanced');
          } else if (!isset(this.avancedReportForm.diseases_ids)) {
            return this.validationInputsRequired('disease_advanced');
          } else if (
            this.avancedReportForm.bySel != 'daterange' &&
            this.avancedReportForm.bySel != 'monthrange' &&
            (this.avancedReportForm.year_sel_init == null ||
              this.avancedReportForm.year_sel_end == null)
          ) {
            return this.validationInputsRequired('year');
          } else if (
            this.avancedReportForm.year_sel_end == null &&
            this.avancedReportForm.bySel == 'week'
          ) {
            return this.validationInputsRequired('year');
          } else if (
            this.avancedReportForm.week_sel_init == null &&
            this.avancedReportForm.bySel == 'week'
          ) {
            return this.validationInputsRequired('week');
          } else if (
            this.avancedReportForm.week_sel_end == null &&
            this.avancedReportForm.bySel == 'week'
          ) {
            return this.validationInputsRequired('week');
          } else if (this.rangeDate == null) {
            return this.validationInputsRequired('year');
          } else {
            this.loadAvancedReport();
          }
        }
      });
    },

    loadData() {
      this.pagination.currentPage = 1;
      let data = {
        farms: this.avancedReportForm.farm_id,
        init: null,
        end: null,
        bySel: this.avancedReportForm.bySel,
        diseases: this.avancedReportForm.diseases_ids,
      };

      switch (this.avancedReportForm.bySel) {
        case 'year':
          data.init = this.avancedReportForm.year_sel_init;
          data.end = this.avancedReportForm.year_sel_end;
          break;
        case 'monthrange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
        case 'week':
          data.init = `${this.avancedReportForm.year_sel_init}-${(
            '0' + this.avancedReportForm.week_sel_init
          ).slice(-2)}`;
          data.end = `${this.avancedReportForm.year_sel_end}-${(
            '0' + this.avancedReportForm.week_sel_end
          ).slice(-2)}`;
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    loadAvancedReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'diseases/advancedreport';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data) {
            this.tableData = response.data;
            if (this.tableData.length == 0) {
              SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            } else {
              this.fuseSearch = new Fuse(this.tableData, {
                useExtendedSearch: true,
                keys: this.tableColumns.map((column) => column.prop),
              });
              this.avancedReport = true;
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    handleCloseSamplesMap() {
      this.modals.samplesMap = false;
    },
    handleViewAllSamplesMap() {
      this.modals.samplesMap = true;
      this.showHideLoading(true);
      let points = [];
      let polygons = [];
      this.tableData.forEach((element) => {
        points.push({
          lat: parseFloat(element.latitude),
          lng: parseFloat(element.longitude),
          name: element.disease_name,
          color: element.color,
        });
        if (element.geometry_data) {
          let rings = element.geometry_data.split('/').map((coord) => {
            const [lng, lat] = coord.split(',').map(parseFloat);
            return [lng, lat];
          });
          polygons.push({
            rings: [...rings, rings[0]],
            color: element.pc_color || '#FF0000',
            disease_name: element.disease_name,
          });
        }
      });
      // 🔹 Cálculo dinámico del zoom basado en el ancho de la pantalla
      let screenWidth = window.innerWidth;
      let dynamicZoom;

      if (screenWidth <= 768) {
        dynamicZoom = 13; // Móviles -> Alejado
      } else if (screenWidth <= 1366) {
        dynamicZoom = 17; // Pantallas medianas -> Zoom estándar
      } else {
        dynamicZoom = Math.min(19, 17 + (screenWidth - 1366) / 500); // Pantallas grandes -> Más cerca (máximo 19)
      }
      setTimeout(() => {
        this.loadBaseMap(
          this.avancedReportForm.farm_id,
          true, // Mostrar medición
          true, // Mostrar lista de capas
          this.$refs.multipleMap,
          points, // Puntos para agregar al mapa
          dynamicZoom, // Zoom inicial
          null, // Sick perimeter (no necesario aquí)
          true, // Mostrar íconos extra
          null, // Color (opcional)
          null, // Nombre de la enfermedad (opcional)
          polygons // NUEVO: Perímetros para agregar al mapa
        );
        document.getElementById('toolbarDiv').style = 'top: 16%;right: 18px;';
        this.showHideLoading();
      }, 10);
      // let data = this.loadData();
      // let init;
      // let end;
      // if (data.bySel != 'year') {
      //   if (typeof data.init === 'string') init = data.init.split('-')[0];
      //   if (typeof data.end === 'string') end = data.end.split('-')[0];
      // } else {
      //   init = data.init;
      //   end = data.end;
      // }
      // if (init != end) {
      //   SweetAlert.warning(i18n.t('common_words.map_cannot_be_displayed'));
      // } else {

      // }
    },
    handleViewSamplesMap(index, rowData) {
      this.modals.samplesMap = true;
      this.showHideLoading(true);

      let points = [];
      let pll = new Object();
      pll.lat = parseFloat(rowData.latitude);
      pll.lng = parseFloat(rowData.longitude);
      pll.color = rowData.color;
      this.center.lat = rowData.latitude;
      this.center.lng = rowData.longitude;

      let sickPerimeter = null;
      //
      if (rowData.geometry_data != null) {
        sickPerimeter = rowData.geometry_data.split('/');
      }
      points.push(pll);

      if (points.length == 0) {
        SweetAlert.warning(i18n.t('sweet_alert.disease.unavailable_dates'));
      }

      setTimeout(() => {
        this.loadBaseMap(
          rowData.farm_id,
          true,
          true,
          this.$refs.multipleMap,
          points,
          20,
          sickPerimeter,
          true,
          rowData.pc_color,
          rowData.disease_name
        );
        document.getElementById('toolbarDiv').style = 'top: 16%;right: 18px;';
        this.showHideLoading();
      }, 10);
    },

    exportToPDF() {
      let data = this.loadData();
      data.route = 'diseases/advancedreport/pdf';
      data.name_file = `${i18n.t('diseases.advanced_disease_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = this.loadData();
      data.route = 'diseases/advancedreport/excel';
      data.name_file = `${i18n.t('diseases.advanced_disease_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('diseases/diseasesonly'),
        Axios.getMasters('diseases/perimeterconditions/indexfield'),
      ])
        .then((response) => {
          this.farms = response[0].data.data;
          this.diseases = response[1].data;
          this.optionsStates = response[2].data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('diseases/advancedreport/years').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('diseases/diseases');
  },

  destroyed() {
    this.deselectedItemOnMenu('diseases/diseases');
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.map-height > .el-dialog > .el-dialog__body > .map {
  height: 90vh;
}
</style>
